import React, {useEffect, useState} from "react";
import "./authorization.style.scss";
import Phone from "./phone/phone.index";
import Code from "./code/code.index";
import {ToastContainer} from "react-toastify";
import Register from "./register/register.index";
import Login from "./login/login.index";
import Loading from "../loading/loading.index";
import Logo from '../assets/images/logo/black logo - wosh.png'

export default function Authorization() {
    const [state, setState] = useState(1)
    const [refral, setRefral] = useState(undefined)

    function changeState(number) {
        setState(number)
    }

    useEffect(() => {
        if(window.location.href.includes('authorization') && state===4)
            setState(1)
        if (window.location.href.split('/').length > 4)
            if (window.location.href.split('/')[4] !== '')
                setRefral(window.location.href.split('/')[4])
    }, [])

    return (
        <div className="TEMX-authorization">
            <ToastContainer
                dir="rtl"
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={true}
                draggable
                style={{fontSize: "13px"}}
            />
            <div className='my-container'>
                <img src={Logo} onClick={() => window.location.replace('/')} className='logo'/>
                {state === 1 && <Phone changeState={changeState}/>}
                {(state === 2 || state === 5) && <Code state={state} changeState={changeState}/>}
                {(state === 3 || state === 6) && <Register refral={refral} state={state}/>}
                {state === 4 && !window.location.href.includes('authorization') &&  <Login changeState={changeState}/> }
                {state===4 && window.location.href.includes('authorization') && <Phone changeState={changeState}/>}

            </div>
        </div>
    );
}
